import { RootState } from 'redux/rootReducer';
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash/isEqual';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

export const getOnlineRegistrations = (state: RootState) => state.data.registrations.data;

export const getRegistrations = createDeepEqualSelector(getOnlineRegistrations, (items) => items);
